import { ExclamationCircleIcon } from '@repo/icons';
import { tr, Translate } from '@repo/locale';
import type { TestId } from '@repo/test-id';
import { Button } from '@repo/ui';
import { generatePath, useNavigate } from 'react-router-dom';

import { SUPPORT_EMAIL } from '@shared/constants/constants';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

interface Props {
  parkingId: string;
  testId: TestId;
}

export default function SignageMissingAlert({ parkingId, testId }: Props) {
  const navigate = useNavigate();

  const handleAddImages = (): void => {
    navigate(generatePath(ROUTE_PATHS[RouteName.MY_PARKING_MANAGE_SIGNAGE], { id: parkingId }));
  };

  return (
    <div
      className="bg-warning-soft border-stroke-warning-subtle text-fg-warning-subtle relative -top-3.5 z-2 -mb-3.5 rounded-b-2xl border px-4 pt-5 pb-2"
      data-testid={testId}
    >
      <div className="flex gap-2 pb-1">
        <div className="pt-2.5">
          <ExclamationCircleIcon />
        </div>
        <div className="flex w-full flex-col gap-1.5 sm:flex-row sm:items-center sm:gap-2">
          <div className="flex grow flex-col gap-1.5">
            <div className="pt-2 text-base leading-6 font-medium text-balance">
              {tr('owned_parking_manage:manage.signage.missing.title')}
            </div>
            <div className="text-sm leading-5 text-balance">
              <Translate
                i18nKey="owned_parking_manage:manage.signage.missing.info"
                values={{ email: SUPPORT_EMAIL }}
                components={{
                  emailLink: (
                    <a
                      href={`mailto:${SUPPORT_EMAIL}`}
                      className="underline"
                      data-testid={testId.append('emailLink')}
                    />
                  ),
                }}
              />
            </div>
          </div>
          <div className="my-1 flex shrink-0 justify-center sm:my-0">
            <Button
              color="warning"
              label={tr('owned_parking_manage:manage.signage.missing.button')}
              onClick={handleAddImages}
              testId={testId.append('addImagesButton')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
